import { createTheme } from "@mui/material";

export const theme = createTheme({
  components: {
    MuiAlert: {
      styleOverrides: {
        standardSuccess: {
          color: "green",
          alignItems: "center",
          borderRadius: "4px",
          boxShadow: "0px 7px 9px -2px rgba(0,128,0,0.3)",
        },
        standardError: {
          color: "red",
          alignItems: "center",
          borderRadius: "4px",
          boxShadow: "0px 7px 9px -2px #ff0000",
        },
        standardWarning: {
          alignItems: "center",
          borderRadius: "4px",
          color: "orange",
        },
        standardInfo: {
          alignItems: "center",
          borderRadius: "4px",
          color: "grey",
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: "success" },
              style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "5px !important",
                animation: `progressAnimation 5000ms linear forwards`,
                "@keyframes progressAnimation": {
                  "0%": { width: "100%" },
                  "100%": { width: "0%" },
                },
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "green !important",
                },
              },
            },
            {
              props: { variant: "error" },
              style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "5px !important",
                animation: `progressAnimation 5000ms linear forwards`,
                "@keyframes progressAnimation": {
                  "0%": { width: "100%" },
                  "100%": { width: "0%" },
                },
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "red !important",
                },
              },
            },
          ],
        },
      },
    },
  },
});
